import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const links = [
  { label: 'ABOUT', href: '#about' },
  { label: 'PRICE LIST', href: '#price-list' },
  { label: 'GALLERY', href: '#gallery' },
  { label: 'BOOK', href: '#availability' },
  { label: 'VOUCHERS', href: '#vouchers' },
  { label: 'REVIEWS', href: '#reviews' },
  { label: 'CONTACT', href: '#contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'backdrop-blur-md bg-white/10 py-3' : 'py-6'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <button
          onClick={() => scrollTo('#top')}
          className="text-white tracking-[0.35em] text-sm md:text-base font-light hover:opacity-80 transition-opacity"
          style={{ fontFamily: "'Josefin Sans', sans-serif" }}
        >
          BLISSFULL MOBILE SPA
        </button>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <button
                onClick={() => scrollTo(l.href)}
                className="text-white/90 hover:text-white tracking-[0.25em] text-xs font-light transition-colors relative group"
                style={{ fontFamily: "'Josefin Sans', sans-serif" }}
              >
                {l.label}
                <span className="absolute left-0 -bottom-1 h-px w-0 bg-white group-hover:w-full transition-all duration-300" />
              </button>
            </li>
          ))}
        </ul>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="md:hidden mt-3 mx-6 rounded-2xl bg-white/15 backdrop-blur-lg border border-white/20"
          >
            <ul className="flex flex-col py-4">
              {links.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => scrollTo(l.href)}
                    className="w-full text-left px-6 py-3 text-white tracking-[0.25em] text-sm hover:bg-white/10"
                    style={{ fontFamily: "'Josefin Sans', sans-serif" }}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
